<template>
    <div class="mt-4">
        <h5 class="status-label">Connection Information</h5>
        <template v-if="model?.credentials?.org_id && model?.credentials?.token?.instance_url">
            <el-row :gutter="20">
                <el-col :span="24">
                    <span><b>Instance URL:</b> {{ model.credentials.token.instance_url }}</span>
                </el-col>
                <el-col :span="24">
                    <span><b>ID:</b> {{ model.credentials.token.id }}</span>
                </el-col>
                <el-col :span="24">
                    <span><b>Organization ID:</b> {{ model.credentials.org_id }}</span>
                </el-col>
            </el-row>
        </template>
        <template v-if="model?.credentials?.token.scope">
            <el-row :gutter="20" class="mt-2">
                <el-col :span="24">
                    <span><b>Scopes:</b> <code>{{ model.credentials.token.scope }}</code></span>
                </el-col>
            </el-row>
        </template>

        <!-- Access Token (only visible for whitelisted review companies) -->
        <template v-if="showAccessToken && model?.credentials?.token?.access_token">
            <el-row :gutter="20" class="mt-3">
                <el-col :span="24">
                    <span><b>Access Token:</b></span>
                    <div class="d-flex align-items-center mt-1">
                        <code class="token-display">{{ tokenRevealed ? model.credentials.token.access_token : maskedToken }}</code>
                        <button class="token-action-btn ml-2"
                                @click="tokenRevealed = !tokenRevealed">
                            <i :class="tokenRevealed ? 'el-icon-view' : 'el-icon-view'"></i>
                            {{ tokenRevealed ? 'Hide' : 'Reveal' }}
                        </button>
                        <button v-if="tokenRevealed"
                                class="token-action-btn ml-2"
                                v-clipboard:copy="model.credentials.token.access_token"
                                v-clipboard:success="onCopy">
                            <i class="el-icon-document-copy"></i> Copy
                        </button>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="mt-1">
                <el-col :span="24">
                    <small class="text-muted">This token expires periodically. Use the Aloware app to re-authenticate if it stops working.</small>
                </el-col>
            </el-row>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        model: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            tokenRevealed: false,
        }
    },
    computed: {
        showAccessToken() {
            return this.model?.show_access_token === true
        },
        maskedToken() {
            const token = this.model?.credentials?.token?.access_token
            if (!token) {
                return ''
            }
            return token.substring(0, 15) + '...' + token.substring(token.length - 10)
        },
    },
    methods: {
        onCopy() {
            this.$notify({
                message: 'Access token copied to clipboard.',
                type: 'success',
            })
        },
    },
}
</script>
<style scoped>
.token-display {
    word-break: break-all;
    font-size: 12px;
    max-width: 500px;
    display: inline-block;
}
.token-action-btn {
    background: none;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 4px 8px;
    cursor: pointer;
    font-size: 12px;
    color: #606266;
    transition: color 0.3s, border-color 0.3s;
    white-space: nowrap;
}
.token-action-btn:hover {
    color: #00a344;
    border-color: #00a344;
}
</style>
